/**
 *
 * Asynchronously loads the component for AdminDeleteBadge
 *
 */

import React, { Suspense } from 'react';

const LazyComponent = React.lazy(() => import('./index'));

export default props => (
  <Suspense fallback={''}>
    <LazyComponent {...props} />
  </Suspense>
);
